import {createContext} from 'react';

const contexto = createContext();
export const {Provider,Consumer} = contexto;

export default contexto;